import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { ALERT_SEVERITY } from '../enum/snackbarProps';
import useSnackbarContext from '../context/SnackbarContext';
import useMainProgressContext from '../../progress/MainProgress/context/MainProgressContext';

interface SnackbarSettingsProps {
  disableErrorAction?: boolean;
  disableSuccessAction?: boolean;
  successMessage?: string;
  errorMessage?: string;
  hideSuccessMessage?: boolean;
  hideErrorMessage?: boolean;
  apiRequestState: API_REQUEST_STATE;
  apiRequestError: string | null;
  setApiRequestState: (apiRequestState: API_REQUEST_STATE) => void;
  onSuccess?: () => void;
  onError?: () => void;
}

const SnackbarSettings: FC<SnackbarSettingsProps> = (props) => {
  const { add } = useSnackbarContext();
  const { hide } = useMainProgressContext();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    switch (props.apiRequestState) {
      case API_REQUEST_STATE.SUCCEEDED_ADD:
      case API_REQUEST_STATE.SUCCEEDED_EDIT:
      case API_REQUEST_STATE.SUCCEEDED_DELETE:
        if (props.disableSuccessAction) {
          return;
        }

        if (!props.hideSuccessMessage) {
          add(ALERT_SEVERITY.SUCCESS, props.successMessage ? t(props.successMessage) : t('snackbar.success'));
        }

        dispatch(props.setApiRequestState(API_REQUEST_STATE.IDLE));
        hide();
        props.onSuccess?.();
        break;
      case API_REQUEST_STATE.FAILED_DELETE_ARTICLE:
        if (props.disableErrorAction) {
          return;
        }
        if (!props.hideErrorMessage) {
          add(
            ALERT_SEVERITY.ERROR,
            props.errorMessage ? t(props.errorMessage) : t('category.snackbar.category_has_articles'),
          );
        }
        dispatch(props.setApiRequestState(API_REQUEST_STATE.IDLE));
        hide();
        props.onError?.();
        break;
      case API_REQUEST_STATE.FAILED_DELETE_SUBCATEGORY:
        if (props.disableErrorAction) {
          return;
        }
        if (!props.hideErrorMessage) {
          add(
            ALERT_SEVERITY.ERROR,
            props.errorMessage ? t(props.errorMessage) : t('category.snackbar.category_has_subcategory'),
          );
        }
        dispatch(props.setApiRequestState(API_REQUEST_STATE.IDLE));
        hide();
        props.onError?.();
        break;
      case API_REQUEST_STATE.FAILED:
        if (props.disableErrorAction) {
          return;
        }
        if (!props.hideErrorMessage) {
          add(ALERT_SEVERITY.ERROR, props.errorMessage ? t(props.errorMessage) : (props.apiRequestError as string));
        }
        dispatch(props.setApiRequestState(API_REQUEST_STATE.IDLE));
        hide();
        props.onError?.();
        break;
    }
  }, [props.apiRequestState, props.apiRequestError]);

  return null;
};

export default SnackbarSettings;
